module.exports = __webpack_public_path__ + "static/media/IC_Perf_Measuring.f68a793b.svg";